import React, { Component } from "react";

class DeleteModal extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.blogToDelete &&
      this.props.blogToDelete !== prevProps.blogToDelete
    ) {
      const modal = new window.bootstrap.Modal(
        document.getElementById("deleteModal")
      );
      modal.show();
    }
  }

  handleClose = () => {
    const modal = window.bootstrap.Modal.getInstance(
      document.getElementById("deleteModal")
    );
    if (modal) modal.hide();
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  };

  render() {
    const { onConfirmDelete } = this.props;

    return (
      <div
        className="modal fade"
        id="deleteModal"
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteModalLabel">
                Confirm Delete
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete this blog? This action cannot be
              undone.
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  onConfirmDelete();
                  this.handleClose();
                }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeleteModal;
